export const SUPPORTS_ARRAY_PROTOTYPE_REVERSE = "reverse" in Array.prototype;
